import React from "react"
import { BrowserRouter, Link, Route, Routes } from "react-router-dom"
import { DiggerComponent } from "./components/Digger"
import { StatsComponent } from "./components/Stats"
import { MapComponent } from "./components/Map"
import { ListComponent } from "./components/List"
import { IndexComponent } from "./components/Index"
import { BarComponent } from "./components/Bar"
import { BarsComponent } from "./components/Bars"
import Snowflakes from "magic-snowflakes"

function App() {
  const clickLogoEvent = () => {
    // @ts-ignore
    ym(92771670, "reachGoal", "clickLogo")
  }
  const openIndexEvent = () => {
    // @ts-ignore
    ym(92771670, "reachGoal", "openIndex")
  }
  const openMapEvent = () => {
    // @ts-ignore
    ym(92771670, "reachGoal", "openMap")
  }
  const openListsEvent = () => {
    // @ts-ignore
    ym(92771670, "reachGoal", "openLists")
  }
  const openBarsEvent = () => {
    // @ts-ignore
    ym(92771670, "reachGoal", "openBars")
  }
  const openStatsEvent = () => {
    // @ts-ignore
    ym(92771670, "reachGoal", "openStats")
  }

  const hasNews = false

  React.useEffect(() => {
    const snowflakes = new Snowflakes({
      color: "#5ECDEF", // Default: "#5ECDEF"
    })
    const snowflakes2 = new Snowflakes({
      color: "#E5BBEB", // Default: "#5ECDEF"
    })
    snowflakes.start()
    snowflakes2.start()
  })

  return (
    <div className="App">
      <BrowserRouter>
        <div className="logo">
          <Link to={`/`} onClick={clickLogoEvent}>
            <img
              src="/images/gm_logo_ny.png"
              alt="gm logo"
              className="logoImg"
            />
          </Link>
        </div>
        <div className="navigation">
          {!hasNews && (
            <Link to={`/`} onClick={openMapEvent}>
              Карта
            </Link>
          )}
          {hasNews && (
            <Link to={`/`} onClick={openIndexEvent}>
              Новости
            </Link>
          )}
          {hasNews && (
            <Link to={`/map`} onClick={openMapEvent}>
              Карта
            </Link>
          )}
          <Link to={`/lists`} onClick={openListsEvent}>
            Мили
          </Link>
          <Link to={`/bars`} onClick={openBarsEvent}>
            Бары
          </Link>
          <Link to={`/stats`} onClick={openStatsEvent}>
            Участники
          </Link>
        </div>
        <Routes>
          {!hasNews && <Route path="/" element={<MapComponent />}></Route>}
          {hasNews && <Route path="/" element={<IndexComponent />}></Route>}
          {hasNews && <Route path="/map" element={<MapComponent />}></Route>}
          <Route path="/stats" element={<StatsComponent />}></Route>
          <Route path="/lists" element={<ListComponent />}></Route>
          <Route path="/diggers/:id" element={<DiggerComponent />} />
          <Route path="/bars" element={<BarsComponent />} />
          <Route path="/bars/:id" element={<BarComponent />} />
        </Routes>
      </BrowserRouter>
      <div className="footer">2023, kverty ❤ tinder</div>
    </div>
  )
}

export default App
